var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil-water-1 {fill:#3283C9;fill-rule:nonzero}\n    .fil-water-0 {fill:url(#id0)}\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 528.52,
    y1: 1091.52,
    x2: 599.48,
    y2: 62.29
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#367AB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#C7E5FF"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil-water-1",
    d: "M8 0.03279L8.0257 0L8.44055 0.56997C9.97635 2.68055 11.3532 4.60043 12.3441 6.32536C13.3678 8.10728 13.9966 9.70902 14 11.1412L13.9978 11.1698C13.991 12.518 13.4135 13.7371 12.3082 14.6188C11.298 15.4244 9.84865 15.9404 8 16V14.9902C9.58415 14.9356 10.8054 14.5081 11.6379 13.8441C12.4947 13.1606 12.9431 12.2143 12.9469 11.1679L12.9491 11.1412C12.9482 9.90485 12.3677 8.45652 11.4224 6.8117C10.5361 5.26914 9.34075 3.57322 8 1.72369V0.03279Z",
    fill: "#3283C9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil-water-1",
    d: "M8 0.03279L7.9743 0L7.55945 0.56997C6.02365 2.68055 4.64681 4.60043 3.65592 6.32536C2.63226 8.10728 2.00339 9.70902 2 11.1412L2.00221 11.1698C2.009 12.518 2.58651 13.7371 3.69178 14.6188C4.702 15.4244 6.15134 15.9404 8 16V14.9902C6.41585 14.9356 5.19453 14.5081 4.36212 13.8441C3.50523 13.1606 3.05687 12.2143 3.05303 11.1679L3.05096 11.1412C3.05184 9.90485 3.6323 8.45652 4.57759 6.8117C5.46388 5.26914 6.65925 3.57322 8 1.72369V0.03279Z",
    fill: "#3283C9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.8593b36af1e8edf0a1a8a1def3b3422a.svg";
export { ForwardRef as ReactComponent };